/**
 * Marketplace — Coming soon
 */

import { T } from '../styles/tokens';

export function MarketplacePage() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40, textAlign: 'center' }}>
      <div>
        <h2 style={{ fontSize: 28, marginBottom: 12 }}>Marketplace</h2>
        <p style={{ color: T.textSecondary, marginTop: 12, fontSize: 16, maxWidth: 400 }}>
          O Marketplace está em desenvolvimento. Em breve você poderá encontrar agentes, skills e templates aqui!
        </p>
      </div>
    </div>
  );
}
